import { IConfig } from '@unleash/proxy-client-react';

export const unleashClientConfig: IConfig = {
    appName: 'insights-ui',
    environment: process.env.REACT_APP_UNLEASHED_ENVIRONMENT,
    url: process.env.REACT_APP_UNLEASHED_API_URL!,
    clientKey: process.env.REACT_APP_UNLEASHED_CLIENT_KEY!,
    refreshInterval: parseInt(process.env.REACT_APP_UNLEASHED_FLAGS_UPDATE_INTERVAL_SEC!, 10) || 30,
};
